import { Grid } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import {
  InboxSidebarOptionKey,
  OutreachContactsContext,
} from "contexts/OutreachContacts";
import { useContext } from "react";

import SearchBar from ".";
import SortSelect from "./Filters/SortSelect";
import StarredSelect from "./Filters/StarredSelect";

const InboxSearchBarMenu = () => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const { currentSidebarOption } = useContext(OutreachContactsContext);
  return (
    <Grid>
      {currentSidebarOption?.key !== InboxSidebarOptionKey.checkins && (
        <Grid container alignItems="center" gap={2}>
          <Grid item xs={12} md={!currentOrg?.isBrand ? 6 : true}>
            <SearchBar />
          </Grid>
          <Grid item xs="auto" md="auto">
            <SortSelect />
          </Grid>
          {currentSidebarOption?.key === InboxSidebarOptionKey.inbox && (
            <Grid item xs="auto" md={1}>
              <StarredSelect />
            </Grid>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default InboxSearchBarMenu;
